import * as types from './actionTypes';  
import userDetailApi from '../api/userDetailApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';

export function doUserDetail(email) {

  return {
    type: types.DO_USER_DETAILS, 
    email
  };
}

export function doUserDetailRes(data) {  
  return {
    type: types.DO_USER_DETAILS_RES, 
    data
  };
}

export function getUserDetail(email) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      userDetailApi.doUserDetail(email).then(data => {
        dispatch(doUserDetailRes(data));
        dispatch(doUserDetailRes(null));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        return error
      });
    };
  }else{
    logout()
  }
}

